import { Controller } from 'stimulus'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

import { createBaseMap, destroyBaseMap, pinIcon } from './shared/leaflet_map'

export default class extends Controller {
  static targets = ['container']

  connect() {
    const markers = JSON.parse(this.data.get('markers') || '[]')
    if (markers.length === 0) return

    this.map = createBaseMap(this.containerTarget, { zoom: 15 })
    const points = markers.map(marker => {
      const position = [marker.lat, marker.lng]
      if (marker.accuracy) {
        L.circle(position, { radius: marker.accuracy, weight: 1, color: '#2563eb', fillOpacity: 0.08 }).addTo(this.map)
      }
      L.marker(position, { icon: pinIcon('#2563eb') })
        .bindPopup(this._popup(marker), { minWidth: 180 })
        .addTo(this.map)
      return position
    })

    if (points.length === 1) {
      this.map.setView(points[0], 17)
    } else {
      this.map.fitBounds(L.latLngBounds(points), { padding: [30, 30], maxZoom: 18 })
    }
  }

  disconnect() {
    destroyBaseMap(this.map)
    this.map = null
  }

  _popup(marker) {
    const box   = document.createElement('div')
    const image = document.createElement('img')
    image.src = marker.thumb
    image.style.cssText = 'display:block;width:180px;height:auto;border-radius:4px;margin-bottom:6px;'
    box.appendChild(image)
    marker.lines.forEach(line => {
      const row = document.createElement('div')
      row.textContent = line
      box.appendChild(row)
    })
    return box
  }
}
